// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  version: require('../../../../package.json').version,
  production: false,
  tkWebUrl: 'https://tkweb-uat.takad.com.hk/TKWeb/restful/1.0',
  // tkWebUrl: 'http://127.0.0.1:18080/TKWeb/restful/1.0',
  baseUrl: 'https://tkd-restful-uat.takad.com.hk/v1',
  // baseUrl: 'http://127.0.0.1:8777/v1',
  invoiceCss: 'https://www.takad.com.hk/tools/invoice-tricolor_uat.css',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error'; // Included with Angular CLI.
